import { useNavigate } from "react-router-dom";
import Button from "../../../../../shared/components/Button";
import Card from "../../../../../shared/components/Card";
import SecondaryIcon from "../../../../../shared/components/SecondaryIcon";
import Icons from "../../../../../shared/constants/icon.constant";
import AvailableBalance from "./AvailableBalance";

type WalletBalanceProps = {
  amountDisplay?: string;
  currencyLabel?: string;
  isLoading: boolean;
  errorMessage?: string;
};

export default function WalletBallance({
  amountDisplay,
  currencyLabel,
  isLoading,
  errorMessage,
}: Readonly<WalletBalanceProps>) {
  const navigate = useNavigate();

  return (
    <Card title="Wallet" titleSize="md">
      <div className="flex items-center w-full h-full justify-between">
        <AvailableBalance
          amountDisplay={amountDisplay}
          currencyLabel={currencyLabel}
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
        <div className="flex flex-col gap-4">
          <Button
            variant="secondary"
            className="bg-main-dark/50! rounded-lg! gap-2 justify-between! py-3 text-label-dark!"
            fluid
            onClick={() => navigate("/assets/deposit")}>
            <SecondaryIcon icon={Icons.Deposit({ width: 16, height: 16 })} />
            Deposit
          </Button>
          <Button
            variant="secondary"
            className="bg-main-dark/50! rounded-lg! gap-2 justify-between! py-3 text-label-dark!"
            fluid
            onClick={() => navigate("/assets/withdrawal")}>
            <SecondaryIcon icon={Icons.Withdrawal({ width: 16, height: 16 })} />
            Withdraw
          </Button>
        </div>
      </div>
    </Card>
  );
}
